import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
        fill="#0090FF"
      />
      <path
        d="M18.8494 11.9571C19.2399 11.5666 19.2399 10.9334 18.8494 10.5429C18.4589 10.1524 17.8257 10.1524 17.4352 10.5429L12.6424 15.3357L10.5567 13.3358C10.1662 12.9453 9.53303 12.9453 9.1425 13.3358C8.75198 13.7263 8.75198 14.3595 9.1425 14.75L11.9353 17.457C12.3258 17.8476 12.9589 17.8476 13.3495 17.457L18.8494 11.9571Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
